import {
  Component,
  Input,
  OnInit,
  input,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Country } from './../../models/country.models';
import countries from '../../../assets/json/countries.json';
import { debounceTime } from 'rxjs';
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
} from '@justin-s/ngx-intl-tel-input';

@Component({
  selector: 'app-phone-number-input',
  templateUrl: './phone-number-input.component.html',
  styleUrl: './phone-number-input.component.scss',
})
export class PhoneNumberInputComponent implements OnInit {
  @Input() phoneFormGroup: FormGroup;
  @Input() formControlName: String = '';
  CountryISO = CountryISO;
  SearchCountryField = SearchCountryField;
  PhoneNumberFormat = PhoneNumberFormat;
  // @Input() filterForm: FormGroup = this.fb.group({
  //   keyword: [''],
  // });
  // @Input() phoneSelected: any
  // @Input() label: string = "Téléphone"
  // @Input() formArrayName: string = "Téléphone"
  // @Input() formControlName1: string = ""
  // @Input() formControlName: string = ""
  // @Input() required: boolean = false
  // @Input() index: number = 0
  // @Input() search: boolean = false
  // @Output() sendNumber = new EventEmitter<any>()
  // countriesList: Country[] = countries
  // filteredList = this.countriesList

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    // if (this.search) {
    //   this.filterForm
    //     .get('keyword')
    //     ?.valueChanges.pipe(debounceTime(700))
    //     .subscribe((value) => {
    //       if (value) {
    //         this.filteredList = this.countriesList?.filter(
    //           (el) =>
    //             el?.en_short_name
    //               ?.toLocaleLowerCase()
    //               .includes(value?.toLocaleLowerCase()) ||
    //             el?.num_code.includes(value?.toLocaleLowerCase()) ||
    //             el?.nationality
    //               ?.toLocaleLowerCase()
    //               .includes(value?.toLocaleLowerCase())
    //         );
    //       } else {
    //         this.filteredList = this.countriesList;
    //       }
    //     });
    //   this.phoneFormGroup
    //     .get(this.formControlName)
    //     ?.valueChanges.subscribe((value) => {
    //       const code = this.phoneFormGroup.get(this.formControlName1)?.value;
    //       const tel = this.phoneFormGroup.get(this.formControlName)?.value;
    //       this.sendNumber.emit(code + tel);
    //     });
    //   this.phoneFormGroup
    //     .get(this.formControlName1)
    //     ?.valueChanges.subscribe((value) => {
    //       const code = this.phoneFormGroup.get(this.formControlName1)?.value;
    //       const tel = this.phoneFormGroup.get(this.formControlName)?.value;
    //       this.sendNumber.emit(code + tel);
    //     });
    // }
  }
}
